import { render, staticRenderFns } from "./ImsUserTableMenu.vue?vue&type=template&id=d0d857ea&scoped=true&"
import script from "./ImsUserTableMenu.vue?vue&type=script&lang=js&"
export * from "./ImsUserTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d857ea",
  null
  
)

export default component.exports